import React, { useState } from 'react';
import { getMonthData, isSameDay, isWithinRange } from '../../utils/calendarUtils';
import { useDateRange } from '../../hooks/useDateRange';
import DateCell from './DateCell';
import styles from './Calendar.module.css';

const Calendar = ({ year, month, onDateSelect }) => {
  const [currentYear, setCurrentYear] = useState(year);
  const [currentMonth, setCurrentMonth] = useState(month);
  const { startDate, endDate, selectDate } = useDateRange();

  const monthData = getMonthData(currentYear, currentMonth);
  const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const handleDateClick = (date) => {
    selectDate(date);
    if (onDateSelect) onDateSelect(date);
  };

  const isStart = (date) => startDate && isSameDay(date, startDate);
  const isEnd = (date) => endDate && isSameDay(date, endDate);
  const isInRange = (date) => isWithinRange(date, startDate, endDate);

  return (
    <div className={styles.calendarContainer}>
      <div className={styles.weekdays}>
        {weekdays.map((day) => (
          <div key={day}>{day}</div>
        ))}
      </div>
      <div className={styles.daysGrid}>
        {monthData.map((item, idx) => (
          <DateCell
            key={idx}
            date={item.date}
            isCurrentMonth={item.isCurrentMonth}
            isStart={isStart(item.date)}
            isEnd={isEnd(item.date)}
            isInRange={isInRange(item.date)}
            onClick={handleDateClick}
          />
        ))}
      </div>
    </div>
  );
};

export default Calendar;